import Video from 'react-scale/components/ui/video';
import VideoHls from 'react-scale/components/tailwind/VideoHls';
import GradualRegistrationButton from '../gradual-registration-button';

const Hero = () => (
  <section className="relative z-10 mt-20 mb-32 overflow-hidden lg:-translate-y-14 lg:mt-0 lg:mb-0">
    <div className="container flex flex-col lg:space-x-8 lg:flex-row">
      <div className="hidden lg:block w-full max-w-[487px]">
        <Video
          width={220}
          height={220}
          controls={false}
          playing
          loop
          url="https://stream.mux.com/DicmOqFQUPJJ61rLyXnvQki02h01kYqWMG.m3u8"
          className="w-[800px] -ml-36"
        />
      </div>
      <div className="flex items-center">
        <div className="relative flex-1 text-center lg:pl-16 lg:text-left">
          <p className="mx-auto lg:mx-0 text-lg lg:text-base uppercase font-semibold tracking-[3px] text-transform-x-gradient max-w-max">
            October 19th - 21st | Conference
          </p>
          <h2 className="text-5xl font-light lg:my-8 font-aeonik">Operationalizing AI at Scale</h2>
          <div className="w-full my-8 lg:hidden">
            <VideoHls
              width={220}
              height={220}
              controls={false}
              playing
              loop
              muted
              playsinline
              autoPlay
              src="https://stream.mux.com/DicmOqFQUPJJ61rLyXnvQki02h01kYqWMG.m3u8"
            />
          </div>
          <div className="pb-4 space-y-4 text-gray-300">
            <p className="font-medium text-left">
              Join Scale AI as we bring together the world&apos;s brightest AI leaders, visionaries,
              practitioners, and researchers across industries to explore operationalizing AI and
              Machine Learning.
            </p>
            <p>
              This year&apos;s conference will feature three days of in-person and virtual keynote
              presentations, fireside chats, expert panel discussions, and hands-on workshops.
            </p>
          </div>
          <div className="mt-2 ">
            <GradualRegistrationButton />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
